import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SafeUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Observable, startWith, map } from 'rxjs';
import { CategoryService } from 'src/app/service/category.service';
import { ProductService } from 'src/app/service/product.service';
import { ToastrNotificationService } from 'src/app/service/toastr-notification.service';
import { AlreadyAssignedDialogComponent } from '../../already-assigned-dialog/already-assigned-dialog.component';

@Component({
  selector: 'app-add-edit-product',
  templateUrl: './add-edit-product.component.html',
  styleUrls: ['./add-edit-product.component.scss'],
})
export class AddEditProductComponent {
  isAdding: boolean = false;

  addTitle = 'Add Admin';
  editTitle = 'Edit Admin';
  hide = true;
  checked = true;
  isAdd = true;
  productId!: string;
  categories: any;
  filteredOptions!: Observable<any[]> | undefined;
  categoryObject: any;
  @ViewChild('categoryInput')
  categoryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('myForm2') myForm2!: NgForm;
  @ViewChild('oldBatchNgForm') oldBatchNgForm?: NgForm;
  productForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    warrentyPeriodInYears: new FormControl('', [Validators.required]),
    maxWarrentyPeriodInMonths: new FormControl('', [
      Validators.required,
      (control) => {
        return null;
      }
    ]),
    description: new FormControl('', [Validators.required]),
    categoryID: new FormControl('', [Validators.required]),
    image: new FormControl(),
  });

  assignMode: 'range' | 'scan' = 'range';

  batchForm = new FormGroup({
    productId: new FormControl(''),
    startCode: new FormControl(''),
    endCode: new FormControl(''),
    scannedCodes: new FormControl(''),
    registerDate: new FormControl(new Date(), [Validators.required]),
  });

  oldBatchForm = new FormGroup({
    quantity: new FormControl<number | null>(null, [Validators.required, Validators.min(1)]),
    registerDate: new FormControl(new Date(), [Validators.required]),
  });
  isGeneratingOldBatch: boolean = false;
  masterBatches: any[] = [];
  selectedMasterBatchInfo: any = null;
  preview: any = [];
  currentFile: any = [];
  edit: string = '';
  public myAngularxQrCode!: any[];
  public qrCodeDownloadLink: SafeUrl = '';
  qrvalue: any;
  spinner: boolean = false;
  selectedBatch = 10;
  isSubmitting = false;
  batchObject: any;
  linkedProducts: any[] = [];
  selectedLinkedCategoryId: string = '';
  categoryProductsForLinking: any[] = [];
  selectedLinkedProductId: string = '';
  isLoadingCategoryProducts: boolean = false;
  openedFromDetail: boolean = false;

  constructor(
    private productService: ProductService,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private toastr: ToastrNotificationService,
    private dialog: MatDialog
  ) {}

  getWarrantyMonths(): number {
    const years = Number(this.productForm.value['warrentyPeriodInYears']) || 0;
    return years * 12;
  }

  isLinkedProductsAllowed(): boolean {
    const catValue: any = this.productForm?.get('categoryID')?.value;
    let catId: any = null;
    let category: any = null;

    if (catValue) {
      if (typeof catValue === 'object') {
        category = catValue;
        catId = (catValue as any)?._id;
      } else {
        catId = catValue;
      }
    }

    if (!catId && this.categoryObject) {
      if (typeof this.categoryObject === 'object' && this.categoryObject !== null) {
        category = category || this.categoryObject;
        catId = this.categoryObject._id;
      } else {
        catId = this.categoryObject;
      }
    }

    if (this.categories && this.categories.length > 0 && catId) {
      const found = this.categories.find(
        (c: any) => c._id === catId || c._id?.toString() === catId?.toString() || c.name === catId
      );
      if (found) {
        category = found;
      }
    }

    if (category) {
      return category.allowLinkedProducts === true || category.allowLinkedProducts === 'true';
    }
    return false;
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.addTitle);
    this.productId = this.route.snapshot.params['id'];
    this.edit = this.route.snapshot.queryParams['edit'];
    const fromParam = this.route.snapshot.queryParams['from'];
    if (this.edit === 'false' || fromParam === 'detail') {
      this.openedFromDetail = true;
    } else {
      this.openedFromDetail = false;
    }
    if (this.edit === 'false') {
      this.productForm.disable();
    }
    if (this.productId) {
      this.titleService.setTitle(this.editTitle);
      this.isAdd = false;
      this.batchForm.patchValue({ productId: this.productId });
      this.getProductById(this.productId);
    }
    this.getAllCategories();
    this.loadMasterBatches();
  }

  getProductById(id: string) {
    this.productService.getProductById(id).subscribe({
      next: (data) => {
        const rawCategory = data.product[0]?.category || data.product[0]?.categoryID;
        let matchedCategory = rawCategory;
        if (this.categories && this.categories.length > 0 && rawCategory) {
          const rawId = typeof rawCategory === 'object' ? rawCategory._id : rawCategory;
          const found = this.categories.find(
            (c: any) => c._id?.toString() === rawId?.toString() || c.name === rawCategory?.name || c.name === rawCategory
          );
          if (found) {
            matchedCategory = found;
          }
        }
        this.categoryObject = matchedCategory;
        this.productForm.patchValue({
          name: data?.product[0]?.name,
          warrentyPeriodInYears: data?.product[0]?.warrentyPeriodInYears,
          maxWarrentyPeriodInMonths: data?.product[0]?.maxWarrentyPeriodInMonths,
          description: data?.product[0]?.description,
          categoryID: matchedCategory,
        });

        if (data.product[0]?.linkedProducts && data.product[0].linkedProducts.length > 0) {
          this.linkedProducts = data.product[0].linkedProducts
            .filter((lp: any) => lp.productId)
            .map((lp: any) => ({
              productId: lp.productId._id || lp.productId,
              name: lp.productId.name,
              categoryName: lp.productId.categoryID?.name || '',
              warrentyPeriodInYears: lp.productId.warrentyPeriodInYears || 0,
              maxWarrentyPeriodInMonths: lp.productId.maxWarrentyPeriodInMonths || 0,
            }));
        } else {
          this.linkedProducts = [];
        }
      },
      error: (error) => {
        this.toastr.error(
          error.message ? error.message : 'Could not load Product',
          'Error'
        );
      },
      complete: () => {},
    });
  }

  displayFn = (category: any): string => {
    if (!category) return '';
    if (typeof category === 'string') {
      const match = this.categories?.find(
        (c: any) => c._id?.toString() === category.toString() || c.name === category
      );
      return match && match.name ? match.name : category;
    }
    return category && category.name ? category.name : '';
  };

  private _filter(name: string): any {
    const filterValue = name?.toString().toLowerCase();
    return this.categories.filter((option: { name: string }) => {
      option.name.toLowerCase().includes(filterValue);
    });
  }

  getAllCategories() {
    this.categoryService.getAllCategories().subscribe({
      next: async (categories) => {
        this.categories = await categories.categories;
        const currentCategory = this.productForm.get('categoryID')?.value || this.categoryObject;
        if (currentCategory && this.categories && this.categories.length > 0) {
          const currentId = typeof currentCategory === 'object' ? currentCategory._id : currentCategory;
          const found = this.categories.find(
            (c: any) => c._id?.toString() === currentId?.toString() || c.name === currentCategory?.name || c.name === currentCategory
          );
          if (found) {
            this.categoryObject = found;
            this.productForm.patchValue({ categoryID: found });
          }
        }
        this.filteredOptions = this.productForm
          .get('categoryID')
          ?.valueChanges.pipe(
            startWith(''),
            map((category: any) => {
              // (category ? this._filter(category) : this.categories)
              const name =
                typeof category === 'string' ? category : category?.name;
              return name
                ? this._filter(name as string)
                : this.categories?.slice();
            })
          );
      },
      error: (error) => {
        this.toastr.error(
          error.message ? error.message : 'Could not load Categories',
          'Error'
        );
      },
      complete: () => {},
    });
  }

  setAssignMode(mode: 'scan' | 'range'): void {
    this.assignMode = mode;
  }

  getScannedCodeCount(): number {
    const val = this.batchForm.get('scannedCodes')?.value;
    if (!val) return 0;
    const list = val.split(/[\r\n,]+/).map((s: string) => s.trim()).filter(Boolean);
    return list.length;
  }

  clearScannedCodes(): void {
    this.batchForm.patchValue({ scannedCodes: '' });
  }

  loadMasterBatches(): void {
    // Kept for backward compatibility if needed
    this.productService.getAllMasterBatches().subscribe({
      next: (res) => {
        if (res.success) {
          this.masterBatches = res.batches || [];
        }
      },
      error: () => {}
    });
  }

  batchAdd(ignoreAlreadyUsed: boolean = false) {
    if (this.assignMode === 'range') {
      const startCode = (this.batchForm.value.startCode || '').trim();
      const endCode = (this.batchForm.value.endCode || '').trim();
      if (!startCode) {
        this.toastr.warning('Please enter the Start Barcode or QR Code.', 'Warning');
        return;
      }
      if (!endCode) {
        this.toastr.warning('Please enter the End Barcode or QR Code.', 'Warning');
        return;
      }
    } else {
      const scannedCodes = (this.batchForm.value.scannedCodes || '').trim();
      if (!scannedCodes) {
        this.toastr.warning('Please focus on the text area and scan or enter codes.', 'Warning');
        return;
      }
    }

    const rawDate = this.batchForm.value.registerDate;
    if (!rawDate) {
      this.toastr.warning('Please select a valid Manufacture Date.', 'Warning');
      return;
    }

    let formattedDate: string;
    if (rawDate instanceof Date) {
      const year = rawDate.getFullYear();
      const month = String(rawDate.getMonth() + 1).padStart(2, '0');
      const day = String(rawDate.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    } else if (typeof rawDate === 'string' && rawDate) {
      const d = new Date(rawDate);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    } else {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    }

    this.isAdding = true;

    const payload: any = {
      productId: this.productId,
      registerDate: formattedDate,
      ignoreAlreadyUsed: ignoreAlreadyUsed,
    };

    if (this.assignMode === 'range') {
      payload.startCode = this.batchForm.value.startCode?.trim();
      payload.endCode = this.batchForm.value.endCode?.trim();
    } else {
      payload.codes = this.batchForm.value.scannedCodes;
    }

    this.productService.assignBatchToProduct(payload).subscribe({
      next: (data) => {
        this.isAdding = false;

        // If some codes are already assigned, prompt user with confirmation dialog
        if (data.requiresConfirmation) {
          const dialogRef = this.dialog.open(AlreadyAssignedDialogComponent, {
            width: '600px',
            disableClose: true,
            data: {
              totalRequested: data.totalRequested,
              usedCount: data.usedCount,
              availableCount: data.availableCount,
              alreadyUsedCodes: data.alreadyUsedCodes || [],
            },
          });

          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              // User confirmed: add unused codes and ignore used ones
              this.batchAdd(true);
            }
          });
          return;
        }

        if (data.success) {
          this.batchObject = data.batch;
          const assignedCount = data.assignedCount || data.batch?.totalProducts || '';
          const msg = data.alreadyUsedCount && data.alreadyUsedCount > 0
            ? `Assigned ${assignedCount} code(s) successfully! (${data.alreadyUsedCount} already used codes ignored)`
            : (data.message || 'Batch / Codes assigned to product successfully!');
          this.toastr.success(msg, 'Success');

          // Reset fields
          this.myForm2?.resetForm({
            productId: this.productId,
            startCode: '',
            endCode: '',
            scannedCodes: '',
            registerDate: new Date(),
          });
          this.batchForm.reset({
            productId: this.productId,
            startCode: '',
            endCode: '',
            scannedCodes: '',
            registerDate: new Date(),
          });
          this.batchForm.markAsPristine();
          this.batchForm.markAsUntouched();
        } else {
          this.toastr.warning(
            data.error ? data.error : 'Codes could not be assigned',
            'Warning'
          );
        }
      },
      error: (error) => {
        this.isAdding = false;
        const errorMsg = error.error?.error || error.message || 'Could not assign codes';
        this.toastr.error(errorMsg, 'Error');
      },
      complete: () => {},
    });
  }

  oldBatchAdd() {
    if (this.oldBatchForm.invalid) {
      this.oldBatchForm.markAllAsTouched();
      this.toastr.warning('Please enter a valid quantity and manufacture date.', 'Warning');
      return;
    }

    const quantity = Number(this.oldBatchForm.value.quantity);
    if (!quantity || quantity <= 0) {
      this.toastr.warning('Quantity must be greater than 0.', 'Warning');
      return;
    }

    const rawDate = this.oldBatchForm.value.registerDate;
    if (!rawDate) {
      this.toastr.warning('Please select a valid Manufacture Date.', 'Warning');
      return;
    }

    let formattedDate: string;
    if (rawDate instanceof Date) {
      const year = rawDate.getFullYear();
      const month = String(rawDate.getMonth() + 1).padStart(2, '0');
      const day = String(rawDate.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    } else if (typeof rawDate === 'string' && rawDate) {
      const d = new Date(rawDate);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    } else {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      formattedDate = `${year}-${month}-${day}T00:00:00.000Z`;
    }

    this.isGeneratingOldBatch = true;
    this.isAdding = true;

    const payload = {
      productId: this.productId,
      quantity: quantity,
      registerDate: formattedDate,
    };

    this.productService.addBatchQuantity(payload).subscribe({
      next: (data) => {
        this.isGeneratingOldBatch = false;
        this.isAdding = false;
        if (data.success && data.batch) {
          this.batchObject = data.batch;
          this.myAngularxQrCode = (data.batch.productCodes || []).map((code: string) => {
            return JSON.stringify({
              productCode: code,
            });
          });
          this.oldBatchForm.reset({
            quantity: null,
            registerDate: new Date(),
          });
          if (this.oldBatchNgForm) {
            this.oldBatchNgForm.resetForm({
              quantity: null,
              registerDate: new Date(),
            });
          }
          this.toastr.success('Batch added and QR codes generated successfully! You can now download the stickers.', 'Success');
        } else {
          this.toastr.warning(
            data.error?.message || data.error || 'Batch could not be added',
            'Warning'
          );
        }
      },
      error: (error) => {
        this.isGeneratingOldBatch = false;
        this.isAdding = false;
        this.toastr.error(
          error.error?.message || error.error || error.message || 'Could not add Batch',
          'Error'
        );
      },
    });
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  getBase64Image(img: any) {
    // var canvas = document.createElement('canvas');
    // canvas.width = img.width;
    // canvas.height = img.height;
    // var ctx = canvas.getContext('2d');
    // ctx?.drawImage(img, 0, 0);
    var dataURL = img.toDataURL('image/png');
    return dataURL;
  }

  async download() {
    let batch = this.batchObject;
    this.isAdding = true;   
    this.isGeneratingOldBatch = true;

    let imgDataArr = [];
    let codesArr = [];

    for (const f of this.myAngularxQrCode) {
      this.qrvalue = JSON.stringify({
        productId: this.productId,
        productCode: f,
      });

      while (!document.querySelector('qr-code canvas')) {
        await new Promise((r) => setTimeout(r, 500));
      }

      const qrcode = document.getElementById(f);

      let imageData = this.getBase64Image(qrcode?.firstChild);

      let jsonData = JSON.parse(f);
      codesArr.push(jsonData.productCode);

      imgDataArr.push(imageData);
    }
    let name: any = this.productForm.value['name'];
    this.generatePDF(
      imgDataArr,
      codesArr,
      name,
      this.categoryObject?.stickerFlag || '0'
    );
    this.isAdding = false;
    this.isGeneratingOldBatch = false;

    // doc.save('FirstPdf.pdf');
  }

  getFormattedDate(): string {
    const date = new Date();
    const pad2 = (n: any) => (n < 10 ? '0' + n : n);
    return `${date.getFullYear()}${pad2(date.getMonth() + 1)}${pad2(
      date.getDate()
    )}${pad2(date.getHours())}${pad2(date.getMinutes())}${pad2(
      date.getSeconds()
    )}`;
  }

  generatePDF(
    imgDataArr: string[],
    codesArr: string[],
    productName: string,
    stickerFlag: string
  ) {
    if (stickerFlag == '0') {
      //  1 * 1 BARCODE STICKER 50 by 50 mm flag 0
      let doc = new jsPDF('p', 'mm', [50, 50]);
      let x = 2.5;
      let y = 2.5;
      let w = 45;
      let h = 45;
      let pageWidth = doc.internal.pageSize.getWidth();
      let index = 0;
      const lastIndex = imgDataArr.length - 1;
      for (const data of imgDataArr) {
        doc.addImage(data, 'JPEG', x, y, w, h);
        // Add product code text below the image
        const productCode = `${codesArr[index]}`;
        doc.setFontSize(10);
        const textY = y + h + 1;
        doc.text(productCode, x + w / 2, textY, { align: 'center' });
        if (index == lastIndex) {
          break;
        }
        index++;
        doc.addPage([50, 50]);
      }

      const fileName = `${productName}_${this.getFormattedDate()}`;
      doc.save(fileName);
    } else if (stickerFlag == '1') {
      let doc = new jsPDF('p', 'mm', [25, 100]);
      let x = 0;
      let y = 0;
      let w = 22;
      let h = 22;
      let pageWidth = doc.internal.pageSize.getWidth();
      let pageHeight = doc.internal.pageSize.getHeight();
      let index = 0;
      const lastIndex = imgDataArr.length - 1;

      const topMargin = 0;
      y = topMargin;

      for (const data of imgDataArr) {
        x = (pageWidth - w) / 2;

        doc.addImage(data, 'JPG', x, y, w, h);

        const productCode = `${codesArr[index]}`;
        doc.setFontSize(6);

        const textY = y + h;
        doc.text(productCode, x + w / 2, textY, { align: 'center' });

        if (index === lastIndex) {
          break;
        }

        index++;
        y = y + 25;

        if (y >= pageHeight - 10) {
          doc.addPage([25, 100]);
          y = topMargin; 
        }
      }

      const fileName = `${productName}_${this.getFormattedDate()}`;
      doc.save(fileName);
    }
  }

  onLinkedCategoryChange(categoryId: string) {
    this.selectedLinkedProductId = '';
    this.categoryProductsForLinking = [];
    if (!categoryId) return;

    this.isLoadingCategoryProducts = true;
    this.productService.getCategoryWiseProducts(categoryId).subscribe({
      next: (res) => {
        this.isLoadingCategoryProducts = false;
        const products = res.products || [];
        this.categoryProductsForLinking = products.filter(
          (p: any) => !this.productId || p._id !== this.productId
        );
      },
      error: () => {
        this.isLoadingCategoryProducts = false;
        this.toastr.error('Could not load products for selected category', 'Error');
      }
    });
  }

  addLinkedProduct() {
    if (!this.selectedLinkedProductId) {
      this.toastr.warning('Please select a product item to link', 'Warning');
      return;
    }

    const alreadyExists = this.linkedProducts.some(
      (item) => item.productId === this.selectedLinkedProductId
    );
    if (alreadyExists) {
      this.toastr.warning('This product item is already linked', 'Warning');
      return;
    }

    const product = this.categoryProductsForLinking.find(
      (p: any) => p._id === this.selectedLinkedProductId
    );
    if (!product) return;

    const category = this.categories.find(
      (c: any) => c._id === this.selectedLinkedCategoryId
    );

    this.linkedProducts.push({
      productId: product._id,
      name: product.name,
      categoryName: category?.name || '',
      warrentyPeriodInYears: product.warrentyPeriodInYears || 0,
      maxWarrentyPeriodInMonths: product.maxWarrentyPeriodInMonths || 0,
    });

    this.selectedLinkedProductId = '';
  }

  removeLinkedProduct(index: number) {
    this.linkedProducts.splice(index, 1);
  }

  enableEditMode(): void {
    this.openedFromDetail = true;
    this.edit = 'true';
    this.productForm.enable();
    this.titleService.setTitle(this.editTitle);
    this.router.navigate(['/editProduct/', this.productId], {
      queryParams: { edit: 'true', from: 'detail' },
    });
  }

  onCancelEdit(): void {
    if (this.openedFromDetail) {
      this.edit = 'false';
      this.productForm.disable();
      this.titleService.setTitle('Product Details');
      if (this.productId) {
        this.getProductById(this.productId);
      }
      this.router.navigate(['/editProduct/', this.productId], {
        queryParams: { edit: 'false' },
      });
    } else {
      this.router.navigate(['../../product']);
    }
  }

  productEdit() {
    const data: any = {
      productId: this.productId,
      name: this.productForm.value['name'],
      warrentyPeriodInYears: this.productForm.value['warrentyPeriodInYears'],
      maxWarrentyPeriodInMonths: this.productForm.value['maxWarrentyPeriodInMonths'],
      description: this.productForm.value['description'],
      categoryID: this.productForm.value['categoryID'],
      linkedProducts: this.isLinkedProductsAllowed() ? this.linkedProducts.map((p) => ({ productId: p.productId })) : [],
    };
    this.productService.updateProduct(data).subscribe({
      next: (data) => {
        this.isSubmitting = false;
        if (data.success) {
          this.toastr.success('Product edited successfully', 'Success');
          if (this.openedFromDetail) {
            this.edit = 'false';
            this.productForm.disable();
            this.titleService.setTitle('Product Details');
            if (this.productId) {
              this.getProductById(this.productId);
            }
            this.router.navigate(['/editProduct/', this.productId], {
              queryParams: { edit: 'false' },
            });
            return;
          }
          this.router.navigate(['../../product']);
        } else {
          this.toastr.warning(
            data.error.message
              ? data.error.message
              : 'Product could not be edited',
            'Warning'
          );
        }
      },
      error: (error) => {
        this.isSubmitting = false;
        this.toastr.error(
          error.message ? error.message : 'Product could not be edited',
          'Error'
        );
      },
      complete: () => {
        this.isSubmitting = false;
      },
    });
  }

  onEdit() {
    if (this.edit === 'false') {
      this.enableEditMode();
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    const rawValue = this.productForm.getRawValue();
    const years = Number(rawValue['warrentyPeriodInYears']) || 0;
    const maxMonths = Number(rawValue['maxWarrentyPeriodInMonths']) || 0;
    if (maxMonths <= years * 12) {
      this.productForm.controls['maxWarrentyPeriodInMonths'].setErrors({ invalidMaxWarranty: true });
      return;
    }

    this.isSubmitting = true;
    this.productEdit();
  }

  onAdd() {
    const years = Number(this.productForm.value['warrentyPeriodInYears']) || 0;
    const maxMonths = Number(this.productForm.value['maxWarrentyPeriodInMonths']) || 0;
    if (maxMonths <= years * 12) {
      this.productForm.controls['maxWarrentyPeriodInMonths'].setErrors({ invalidMaxWarranty: true });
      return;
    }

    const category: any = this.productForm.value['categoryID'];
    var formdata: any = new FormData();
    for (const file of this.currentFile) {
      formdata.append('image', file);
    }
    formdata.append(
      'warrentyPeriodInYears',
      this.productForm?.value['warrentyPeriodInYears']
    );
    formdata.append(
      'maxWarrentyPeriodInMonths',
      this.productForm?.value['maxWarrentyPeriodInMonths']
    );
    formdata.append('name', this.productForm.value['name']);
    formdata.append('description', this.productForm.value['description']);
    formdata.append('categoryID', category._id);
    formdata.append(
      'linkedProducts',
      JSON.stringify(this.isLinkedProductsAllowed() ? this.linkedProducts.map((p) => ({ productId: p.productId })) : [])
    );

    this.productService.createProduct(formdata).subscribe({
      next: (data) => {
        console.log(data, 'test');

        if (data.success) {
          this.toastr.success('Product added successfully', 'Success');
        } else {
          this.toastr.warning(
            data.error.message
              ? data.error.message
              : 'Product could not be added',
            'Warning'
          );
        }
        this.router.navigate(['../product']);
      },
      error: (error) => {
        this.toastr.error(
          error.message ? error.message : 'Product could not be added',
          'Error'
        );
      },
      complete: () => {},
    });
  }

  onFileSelected(event: any) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      const files: FileList | null | any = selectedFiles;

      this.currentFile = <Array<File>>files;
      if (files) {
        this.preview = [];
        for (let index = 0; index < selectedFiles.length; index++) {
          const reader = new FileReader();

          reader.onload = (e: any) => {
            this.preview.push(e.target.result);
          };

          reader.readAsDataURL(selectedFiles[index]);
        }
      }
    }
  }

  onSubmit() {
    if (this.isAdd) {
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.onAdd();
    } else {
      this.onEdit();
    }
    setTimeout(() => {
      // Reset the flag once the operation is complete
      this.isSubmitting = false;
    }, 3000);
  }
}
